const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

function cellClass(rec) {
  if (!rec) return null;
  const day = rec.day || [];
  if (day.length === 0) return "bg-sand-100";
  const pr = day.includes("US-PR");
  if (pr && day.length === 1) return "bg-ember";
  if (pr) return "bg-[#D08A6B]";
  return "bg-sand-400";
}

function projClass(p) {
  if (p.status === "pr") return "bg-[#E0B39C]";
  if (p.status === "pr_at_risk" || p.status === "pr_planned") return "bg-[#F0DCCE]";
  return "bg-sand-200";
}

function tooltip(dateIso, rec) {
  if (!rec) return dateIso;
  const day = (rec.day || []).join(", ") || "unknown";
  const night = rec.night || (rec.day?.length ? "in transit" : "unknown");
  return `${dateIso} · ${day} · night: ${night}`;
}

function projTooltip(dateIso, p) {
  const n = p.name || "?";
  if (p.status === "pr") return `${dateIso} · projected in PR`;
  if (p.status === "pr_at_risk") return `${dateIso} · in PR unless planned trip happens (${n})`;
  if (p.status === "pr_planned") return `${dateIso} · in PR only if planned trip happens (else ${n})`;
  return `${dateIso} · projected away — ${n}${p.status === "away_planned" ? " (planned trip)" : ""}`;
}

export default function YearHeatmap({ timeline, projection, year }) {
  const byDate = {};
  for (const rec of timeline || []) byDate[rec.date] = rec;
  const projByDate = {};
  for (const p of projection?.days || []) projByDate[p.date] = p;
  const hasProj = (projection?.days || []).length > 0;

  const legend = [
    ["bg-ember", "In PR"],
    ["bg-[#D08A6B]", "Travel day touching PR"],
    ["bg-sand-400", "Away"],
    ["bg-sand-100", "Unknown"],
    ...(hasProj
      ? [
          ["bg-[#E0B39C]", "Proj. in PR"],
          ["bg-[#F0DCCE]", "Proj. PR (depends on planned)"],
          ["bg-sand-200", "Proj. away"],
        ]
      : [["bg-surface border border-sand-100", "Future"]]),
  ];

  return (
    <div className="rounded-card border border-hairline bg-surface p-6" data-testid="year-heatmap">
      <p className="label-tag mb-4">{year} day-by-day</p>
      <div className="space-y-1 overflow-x-auto">
        {MONTHS.map((label, mi) => {
          const daysInMonth = new Date(year, mi + 1, 0).getDate();
          return (
            <div key={label} className="flex items-center gap-2">
              <span className="font-mono text-[9px] text-sand-400 tracking-widest w-8 shrink-0">{label}</span>
              <div className="flex gap-[3px]">
                {Array.from({ length: daysInMonth }, (_, di) => {
                  const iso = `${year}-${String(mi + 1).padStart(2, "0")}-${String(di + 1).padStart(2, "0")}`;
                  const rec = byDate[iso];
                  const proj = projByDate[iso];
                  const cls = cellClass(rec) || (proj ? projClass(proj) : "bg-surface border border-sand-100");
                  const tip = rec ? tooltip(iso, rec) : proj ? projTooltip(iso, proj) : iso;
                  return (
                    <div
                      key={iso}
                      className={`w-3 h-3 shrink-0 ${cls}`}
                      title={tip}
                      data-testid={rec ? `heatmap-day-${iso}` : proj ? `heatmap-proj-${iso}` : undefined}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex flex-wrap items-center gap-4 mt-5 pt-4 border-t border-sand-100">
        {legend.map(([cls, label]) => (
          <span key={label} className="flex items-center gap-1.5 font-mono text-[10px] text-sand-500">
            <span className={`w-3 h-3 inline-block ${cls}`} /> {label}
          </span>
        ))}
      </div>
    </div>
  );
}
